var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isEditable)?[_vm._t("default")]:[_c('ElTooltip',{attrs:{"content":_vm.unEditableMessage,"transition":""}},[_vm._t("uneditable")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }